"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const wrap_root_1 = require("./core/wrap-root");
const add_environment_1 = require("./core/add-environment");
const add_root_1 = require("./core/add-root");
const remove_root_1 = require("./core/remove-root");
const wrappedItems = new Map();
const wrapRoot = wrap_root_1.wrapRoot(wrappedItems);
exports.wrapRoot = wrapRoot;
const addEnvironment = add_environment_1.addEnvironment(wrappedItems);
exports.addEnvironment = addEnvironment;
const getEnv = add_environment_1.getEnv(wrappedItems);
exports.getEnv = getEnv;
const addEnvironmentByName = add_environment_1.addEnvironmentByName(wrappedItems);
exports.addEnvironmentByName = addEnvironmentByName;
const addRoot = add_root_1.addRoot(wrappedItems);
exports.addRoot = addRoot;
const getRoot = add_root_1.getRoot(wrappedItems);
exports.getRoot = getRoot;
const removeRoot = remove_root_1.removeRoot(wrappedItems);
exports.removeRoot = removeRoot;
const addRootByName = add_root_1.addRootByName(wrappedItems);
exports.addRootByName = addRootByName;
var add_actions_1 = require("./core/add-actions");
exports.addActions = add_actions_1.addActions;
var add_computations_1 = require("./core/add-computations");
exports.addComputations = add_computations_1.addComputations;
var setter_1 = require("./core/setter");
exports.setter = setter_1.setter;
var revertible_1 = require("./core/revertible");
exports.revertible = revertible_1.revertible;
var all_observable_1 = require("./core/all-observable");
exports.allObservable = all_observable_1.allObservable;
//# sourceMappingURL=index.js.map